import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  ${breakpoint('tablet')`
    flex-direction: ${({ isSlider }) => (isSlider ? 'column' : 'row')};
  `}

  ${({ isSlider }) => {
    if (isSlider) {
      return `
        .slick-arrow {
          z-index: 1;
          border: 2px solid #fff;
          border-radius: 50%;
          height: 50px;
          width: 50px;
          background: rgba(0,0,0,0.2);
          box-shadow: 0 0 30px -15px #000;

          &::before, &::after {
            display: block;
            content: "";
            height: 12px;
            left: 50%;
            width: 12px;
            position: relative;
            opacity: 1;
          }
        }
        .slick-prev {
          left: 60px;

          &::before {
            transform: rotate(45deg) translate(1px, 7px);
            border-left: 2px solid #fff;
            border-bottom: 2px solid #fff;
          }
        }
        .slick-next {
          right: 60px;

          &::before {
            transform: rotate(45deg) translate(-3px, 10px);
            border-right: 2px solid #fff;
            border-top: 2px solid #fff;
          }
        }

        .slick-dots {
          text-align: center;
          height: 50px;
          top: -50px;
          position: relative;
          margin: 0;
          padding: 0;
          text-align: center;

          li{
            display: inline-block;
            margin: 0 5px;
          }

          li button {
            border-radius: 50%;
            height: 20px;
            width: 20px;
            min-height: 0;
            display: block;
            border: 1px solid #fff;
            font-size: 0;
            background: transparent;
            line-height: 0;
            padding: 0;
          }

          li.slick-active button {
            background: #fff;
          }
        }
      `;
    }
  }}
`;

export const ImageWrapper = styled.div`
  flex: 0 0 100%;
  margin: ${({ isSlide }) => (isSlide ? '0' : '10px 0')};

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  ${breakpoint('tablet')`
    margin: ${({ isSlide }) => (isSlide ? `0` : `0 10px`)};
  `}

  ${breakpoint('tablet')`
    flex: 0 1 ${({ imageCount }) => 100 / imageCount}%;

    &:first-child {
      margin-left: 0;
    }
  
    &:last-child {
      margin-right: 0;
    }
  `}
`;

export const Image = styled.img`
  height: auto;
  max-height: 450px;
  max-width: 100%;
  width: auto;
  margin: 0 auto;

  ${breakpoint('tablet')`
    max-height: 700px;
  `}
`;
